import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import cx from 'classnames';
import T from 'i18n-react';
import { Button, Grid, IconButton, Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  Add as AddIcon,
  Clear as ClearIcon,
  Error as ErrorIcon,
  ThumbUp as ThumbUpIcon,
} from '@material-ui/icons';
import { mdiContentCopy as FileCopyIcon } from '@mdi/js';
import Icon from '@mdi/react';
import { actAnyFieldUpdate, actStateDetailChange, actValidate } from 'actions/formActions';
import { actLogin, actQuickRegistration, actUserProfileFetch } from 'actions/loginStateActions';
import icwlogo from 'assets/img/icwlogo.png';
import dzStyles from 'assets/jss/dzStyles';
import loginStyles from 'assets/jss/icw/loginStyle';
import icwStyle from 'assets/jss/icwStyle';
import quickFormStyles from 'assets/jss/views/inspection/createJob/quickFormStyles';
import { ItemGrid } from 'components';
import Dropzone from 'icw-components/Dropzone';
import FormAutoComplete from 'icw-components/FormAutoComplete';
import FormDatePicker from 'icw-components/FormDatePicker';
import FormDropDownList from 'icw-components/FormDropDownList';
import FormTable from 'icw-components/FormTable';
import FormTextField from 'icw-components/FormTextField';
import withStatus from 'icw-components/HOCs/withStatus';
import combineStyles from 'util/combineStyles';
import {
  ApiPrefix,
  countryList,
  filterLocale,
  setDocumentCookie,
  getCookie,
  provinceList,
  stateList,
  validEmail,
  nextPath,
} from 'util/icwUtility';
import {
  // signUpFields as signUpFieldsSchema,
  // loginFields as loginFieldsSchema,
  formFields as formFieldsSchema,
} from 'validation/schemas/inspectionQuickForm';
import { AQLLevel, inspectionLevel, inspectionType } from 'views/Inspection/InspectionValue';
import { actInspectionJobInit, actInspectionJobSubmit } from 'views/Inspection/Job/actions';
import ErrorDialog from 'views/Inspection/Job/Invoice/components/ErrorDialog';
import LoginDialog from './LoginDialog';

const path = window.location.pathname ? window.location.pathname : '';
const lang = filterLocale(path.split('/')[1]);
const locale = lang || (getCookie('locale') ? getCookie('locale') : 'en');

const TextFieldWithStatus = withStatus(FormTextField);
const DropListWithStatus = withStatus(FormDropDownList);
const AutoCompleteWithStatus = withStatus(FormAutoComplete);
const DatePickerWithStatus = withStatus(FormDatePicker);

let dropzoneNo = 0;
let completedDropzoneNo = 0;

const tableHeader = [
  T.translate('inspectionJobWorkspace.itemName'),
  T.translate('inspectionJobWorkspace.itemNo'),
  T.translate('inspectionJobWorkspace.poNo'),
  T.translate('inspectionJobWorkspace.orderQty'),
];

const columnData = (idx) => {
  return ['itemName', 'itemNo', 'poNo', 'orderQty', 'duplicateIcon', 'deleteIcon'].map((key) => {
    switch (key) {
      case 'duplicateIcon':
        return {
          actionButton: true,
          actionTitle: 'Duplicate',
          actionLabel: T.translate('inspectionJobWorkspace.duplicate'),
          classId: 'iconMargin',
          columnId: key,
          storeName: 'inspectionJobWorkspace',
          accessPath: ['inspectionPOReportGroups', idx, 'inspectionPOItems'],
          render: (rec) => <Icon path={FileCopyIcon} />,
        };
      case 'deleteIcon':
        return {
          actionButton: true,
          actionTitle: 'Delete',
          actionLabel: T.translate('inspectionJobWorkspace.delete'),
          columnId: key,
          storeName: 'inspectionJobWorkspace',
          accessPath: ['inspectionPOReportGroups', idx, 'inspectionPOItems'],
          render: (rec) => <ClearIcon />,
        };
      case 'orderQty':
        return {
          type: 'input',
          dataType: 'integer',
          columnId: key,
          storeName: 'inspectionJobWorkspace',
          accessPath: ['inspectionPOReportGroups', idx, 'inspectionPOItems'],
        };
      default:
        return {
          type: 'input',
          columnId: key,
          storeName: 'inspectionJobWorkspace',
          accessPath: ['inspectionPOReportGroups', idx, 'inspectionPOItems'],
        };
    }
  });
};

const ProductInspectionCreate = (props) => {
  const {
    classes,
    history,
    loginState,
    productCategoryList,
    inspectionJobWorkspace,
    inspectionJobWorkspace: { data: inspectionJobWorkspaceData, status: workspaceStatus, errors },
    inspectionJobWorkspace: {
      data: { inspectionId },
    },
    formInit,
    onStateDetailChange,
    onSignUp,
    onAutoLogin,
    onLogin,
    onFieldUpdate,
    onValidate,
    onSubmit,
  } = props;

  const [state, setState] = useState({ isLoginDialogOpen: false, isErrorDialogOpen: false });

  const { isLoginDialogOpen, isErrorDialogOpen } = state;

  useEffect(() => {
    if (!loginState || !loginState.profile) {
      onStateDetailChange('loginState', 'status', 'uninitialized');
    }
    onStateDetailChange('loginState', 'failReason', null);
    formInit();

    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (loginState.status === 'submitting') {
      onSubmit({ ...inspectionJobWorkspace.data, isPublished: true });
    } else if (inspectionJobWorkspace.status === 'uploading') {
      handleUploadFile({
        documentlDz: state.documentlDz,
        imageInfolDz: state.imageInfolDz,
      });
    } else if (inspectionJobWorkspace.status === 'editing') {
      if (getCookie('token')) {
        if (loginState && loginState.profile) {
          onSubmit({
            ...inspectionJobWorkspace.data,
            isPublished: true,
          });
        } else {
          onAutoLogin();
        }
      } else {
        setState({ ...state, isLoginDialogOpen: true });
      }
    } else if (inspectionJobWorkspace.status === 'failed') {
      handleErrorDialog(true);
    } else if (loginState.status === 'failed' && loginState.failReason === 'Unauthorized') {
      setDocumentCookie('token=; expires=Thu, 01-Jan-1970 00:00:01 GMT;');
      setState({ ...state, isLoginDialogOpen: true });
    }

    // eslint-disable-next-line
  }, [loginState.status]);

  function handleAddItem() {
    onFieldUpdate(
      'inspectionJobWorkspace',
      [
        'inspectionPOReportGroups',
        0,
        'inspectionPOItems',
        inspectionJobWorkspace.data.inspectionPOReportGroups[0].inspectionPOItems.length,
      ],
      []
    );
  }

  function handleImageDzChange(dz) {
    setState({ ...state, imageInfolDz: null });
    setState({ ...state, imageInfolDz: dz });
  }

  function handleImageDzSuccess() {
    handleUploadSuccess(nextPath(history));
  }

  function handleDocumentDzChange(dz) {
    setState({ ...state, documentlDz: null });
    setState({ ...state, documentlDz: dz });
  }

  function handleDocumentDzSuccess() {
    handleUploadSuccess(nextPath(history));
  }

  function handleUploadSuccess() {
    completedDropzoneNo++;
    if (completedDropzoneNo === dropzoneNo) {
      onFieldUpdate('loginState', ['status'], 'ready');
      window.location.href = '/inspection';
    }
  }

  function handleUploadFile(dz) {
    Object.keys(dz) &&
      Object.keys(dz).map((key) => {
        if (dz[key] && dz[key].getQueuedFiles().length > 0) {
          dropzoneNo++;
          dz[key].processQueue(dz);
        }
        return null;
      });

    if (dropzoneNo === 0) {
      onFieldUpdate('loginState', ['status'], 'ready');
      window.location.href = '/inspection';
    }
  }

  function handleFormValidation() {
    onValidate(formFieldsSchema, inspectionJobWorkspace);
  }

  function handleLoginDialogClose() {
    setState({ ...state, isLoginDialogOpen: false });
  }

  function handleErrorDialog(value) {
    setState({ ...state, isErrorDialogOpen: value });
    if (!value) {
      onStateDetailChange('inspectionJobWorkspace', 'status', 'editing');
    }
  }

  function handleSignUp(data) {
    if (!data.companyName) {
      onFieldUpdate('loginState', ['failReason'], 'missingCompanyName');
    } else if (!validEmail(data.email) || !data.password) {
      onFieldUpdate('loginState', ['failReason'], 'invalidEmailPassword');
    } else {
      onSignUp(data);
    }
  }

  function handleLogin(data) {
    if (!validEmail(data.email) || !data.password) {
      onFieldUpdate('loginState', ['failReason'], 'invalidEmailPassword');
    } else {
      onLogin(data);
    }
  }

  return [
    <div
      className={cx(classes.notice, {
        [classes.showNotice]: !!loginState.failReason,
      })}
      key={0}>
      {loginState.failReason === 'missingCompanyName'
        ? T.translate(`inspectionJobWorkspace.errors.${loginState.failReason}`)
        : T.translate(`login.errors.${loginState.failReason}`)}
    </div>,

    <ErrorDialog
      storeName='inspectionJobWorkspace'
      title={T.translate('inspectionJobWorkspace.errorDialogTitle')}
      isOpen={isErrorDialogOpen}
      errors={errors}
      onClose={() => {
        handleErrorDialog(false);
      }}
      key={1}
    />,

    <LoginDialog
      classes={classes}
      isOpen={isLoginDialogOpen}
      onClose={handleLoginDialogClose}
      onLogin={handleLogin}
      onSignUp={handleSignUp}
      workspaceStatus={workspaceStatus}
      key={2}
    />,

    <Grid className={classes.quickForm} container key={3}>
      {/** ** Icon *** */}
      <ItemGrid
        xs={12}
        sm={12}
        md={12}
        onClick={() => {
          window.location.href = '/';
        }}>
        <img src={icwlogo} alt='' className={classes.icwlogo} />
      </ItemGrid>
      {/** ** End of Icon *** */}

      {/** ** Title *** */}
      <ItemGrid xs={12} sm={12} md={12} marginBottom>
        <Typography className={classes.pageTitle}>
          {T.translate('inspectionJobWorkspace.quickForm.bookAnInspection')}
        </Typography>
      </ItemGrid>
      {/** ** End of Title *** */}

      {/** ** Reminder *** */}
      <ItemGrid xs={12} sm={10} md={10} marginBottom>
        <Paper className={classes.box}>
          <Grid container>
            <ItemGrid xs={2} sm={2} md={1}>
              <ThumbUpIcon color='primary' />
            </ItemGrid>
            <ItemGrid xs={10} sm={10} md={11} noPadding>
              <Typography className={classes.boxTitle}>
                {T.translate('inspectionJobWorkspace.quickForm.moreRequirements')}
              </Typography>
            </ItemGrid>
          </Grid>
        </Paper>
      </ItemGrid>
      {/** ** End of Reminder *** */}

      {/** ** Inspection Date *** */}
      <ItemGrid xs={12} sm={12} md={12}>
        <Typography className={classes.title}>
          {T.translate('inspectionJobWorkspace.quickForm.whatInspectionDate')}
          <span className={classes.required}> *</span>
        </Typography>
      </ItemGrid>
      <ItemGrid xs={12} sm={6} md={6} marginBottom>
        <DatePickerWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['inspectionDate']}
          InputLabelProps={{ shrink: true }}
          value={inspectionJobWorkspaceData.inspectionDate}
          placeholder='YYYY/MM/DD'
        />
      </ItemGrid>
      {/** ** End of Inspection Date *** */}

      {/** ** Product Category *** */}
      <ItemGrid xs={12} sm={12} md={12}>
        <Typography className={classes.title}>
          {T.translate('inspectionJobWorkspace.quickForm.whatCategory')}
          <span className={classes.required}> *</span>
        </Typography>
        <Typography className={classes.subTitle}>
          {T.translate('inspectionJobWorkspace.quickForm.selectOthers')}
        </Typography>
      </ItemGrid>
      <ItemGrid xs={12} sm={6} md={6} marginBottom>
        <DropListWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['productCategoryId']}
          choices={
            productCategoryList
              ? [
                  {
                    value: 0,
                    label: T.translate('inspectionJobWorkspace.quickForm.selectCategory'),
                  },
                  ...productCategoryList.map((rec) => {
                    return {
                      value: rec.id,
                      label: rec[`name_${locale.replace('-', '')}`],
                    };
                  }),
                ]
              : []
          }
          InputLabelProps={{ shrink: true }}
          noLabel
        />
      </ItemGrid>
      {/** ** End of Product Category *** */}

      {/** ** Items *** */}
      <ItemGrid xs={12} sm={12} md={10}>
        <FormTable
          title={[
            <Typography variant='h6' key={0}>
              {T.translate('inspectionJobWorkspace.quickForm.aboutSampleItems')}
              <span className={classes.required}> *</span>
            </Typography>,
            <Typography variant='caption' key={1}>
              {T.translate('inspectionJobWorkspace.quickForm.fillInInformation')}
            </Typography>,
          ]}
          tableHeader={tableHeader}
          tableBody={inspectionJobWorkspaceData.inspectionPOReportGroups[0].inspectionPOItems}
          columnData={columnData(0)}
          tableFooter={
            <IconButton className={classes.iconButton} onClick={() => handleAddItem()}>
              <AddIcon />
              <Typography variant='subtitle1'>
                {T.translate('inspectionJobWorkspace.addItem')}
              </Typography>
            </IconButton>
          }
          edit
        />
      </ItemGrid>
      {/** ** End of Items *** */}

      {/** ** Images *** */}
      <ItemGrid xs={12} sm={12} md={12} marginBottom>
        <Typography className={classes.title}>
          {T.translate('inspectionJobWorkspace.quickForm.includeImages')}
        </Typography>
        <Typography className={classes.subTitle}>
          {T.translate('inspectionJobWorkspace.quickForm.speedUpQuotation')}
        </Typography>
        <Dropzone
          componentConfig={{ postUrl: `${ApiPrefix}/inspections/files/upload` }}
          djsConfig={{
            headers: { Authorization: getCookie('token') },
            addRemoveLinks: false,
            autoProcessQueue: false,
            acceptedFiles: 'image/png,image/gif,image/jpeg',
            params: {
              type: 'inspectionImage',
              inspectionId: inspectionId || null,
            },
          }}
          className={classes.documentDz}
          layout={<div className='dz-message'>{T.translate('general.upload')}</div>}
          previewTemplate={
            <div className='dz-image-preview'>
              <div className='dz-details'>
                <Icon path={FileCopyIcon} />
                <span data-dz-name />
              </div>
              <div className='dz-remove' data-dz-remove>
                <ClearIcon />
              </div>
            </div>
          }
          onChange={handleImageDzChange}
          onSuccess={handleImageDzSuccess}
        />
      </ItemGrid>
      {/** ** End of Images *** */}

      {/** ** Documents *** */}
      <ItemGrid xs={12} sm={12} md={12} marginBottom>
        <Typography className={classes.title}>
          {T.translate('inspectionJobWorkspace.quickForm.includeDocuments')}
        </Typography>
        <Typography className={classes.subTitle}>
          {T.translate('inspectionJobWorkspace.quickForm.includeDocumentsEg')}
        </Typography>
        <Dropzone
          componentConfig={{ postUrl: `${ApiPrefix}/inspections/files/upload` }}
          djsConfig={{
            headers: { Authorization: getCookie('token') },
            addRemoveLinks: false,
            autoProcessQueue: false,
            params: {
              type: 'inspectionDocument',
              inspectionId: inspectionId || null,
            },
          }}
          className={classes.documentDz}
          layout={<div className='dz-message'>{T.translate('general.upload')}</div>}
          previewTemplate={
            <div className='dz-image-preview'>
              <div className='dz-details'>
                <Icon path={FileCopyIcon} />
                <span data-dz-name />
              </div>
              <div className='dz-remove' data-dz-remove>
                <ClearIcon />
              </div>
            </div>
          }
          onChange={handleDocumentDzChange}
          onSuccess={handleDocumentDzSuccess}
        />
      </ItemGrid>
      {/** ** End of Documents *** */}

      {/** ** Inspection Type *** */}
      <ItemGrid xs={12} sm={12} md={12} noPadding marginBottom>
        <ItemGrid xs={12} sm={6} md={6}>
          <Typography className={classes.title}>
            {T.translate('inspectionJobWorkspace.quickForm.whatInspectionType')}
            <span className={classes.required}> *</span>
          </Typography>
          <DropListWithStatus
            storeName='inspectionJobWorkspace'
            accessPath={['typeOfService']}
            choices={inspectionType || []}
            InputLabelProps={{ shrink: true }}
            noLabel
          />
        </ItemGrid>
      </ItemGrid>
      {/** ** End of Inspection Type *** */}

      {/** ** Inspection Level * */}
      <ItemGrid xs={12} sm={12} md={12} noPadding marginBottom>
        <ItemGrid xs={12} sm={6} md={6}>
          <Typography className={classes.title}>
            {T.translate('inspectionJobWorkspace.quickForm.WhatInspectionLevel')}
            <span className={classes.required}> *</span>
          </Typography>
          <DropListWithStatus
            storeName='inspectionJobWorkspace'
            accessPath={['generalInspectLevel']}
            choices={inspectionLevel || []}
            InputLabelProps={{ shrink: true }}
            noLabel
          />
        </ItemGrid>
      </ItemGrid>
      <ItemGrid xs={12} sm={12} md={12}>
        <Typography className={classes.title}>
          {T.translate('inspectionJobWorkspace.quickForm.specifyAQL')}
          <span className={classes.required}> *</span>
        </Typography>
      </ItemGrid>
      <ItemGrid xs={12} sm={4} md={4} marginBottom>
        <DropListWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['criticalMajorLevel']}
          choices={AQLLevel || []}
          InputLabelProps={{ shrink: true }}
        />
      </ItemGrid>
      <ItemGrid xs={12} sm={4} md={4} marginBottom>
        <DropListWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['criticalMinorLevel']}
          choices={AQLLevel || []}
          InputLabelProps={{ shrink: true }}
        />
      </ItemGrid>
      <ItemGrid xs={12} sm={4} md={4} marginBottom>
        <DropListWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['criticalLevel']}
          choices={AQLLevel || []}
          InputLabelProps={{ shrink: true }}
        />
      </ItemGrid>
      {/** ** End of Inspection Level *** */}

      {/** ** Factory Details * */}
      <ItemGrid xs={12} sm={12} md={12}>
        <Typography className={classes.title}>
          {T.translate('inspectionJobWorkspace.quickForm.factoryInfo')}
          <span className={classes.required}> *</span>
        </Typography>
      </ItemGrid>
      <ItemGrid xs={12} sm={6} md={6}>
        <TextFieldWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['inspectionFactory', 'nameChi']}
          fieldName='factoryNameChi'
        />
        <TextFieldWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['inspectionFactory', 'name']}
          fieldName='factoryNameEng'
        />
      </ItemGrid>
      <ItemGrid xs={12} sm={6} md={6}>
        <Paper className={classes.box}>
          <Grid container>
            <ItemGrid xs={2} sm={2} md={1}>
              <ErrorIcon color='primary' />
            </ItemGrid>
            <ItemGrid xs={10} sm={10} md={11} noPadding>
              <Typography color='primary' className={classes.boxTitle}>
                {T.translate('inspectionJobWorkspace.quickForm.isFactoryChina')}
              </Typography>
              <Typography className={classes.boxContent}>
                {T.translate('inspectionJobWorkspace.quickForm.supplyChineseAddress')}
              </Typography>
            </ItemGrid>
          </Grid>
        </Paper>
      </ItemGrid>
      <ItemGrid xs={12} sm={12} md={12}>
        <TextFieldWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['inspectionFactory', 'addressChi']}
          fieldName='factoryAddressChi'
        />
      </ItemGrid>
      <ItemGrid xs={12} sm={12} md={12}>
        <TextFieldWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['inspectionFactory', 'address']}
          fieldName='factoryAddressEng'
        />
      </ItemGrid>
      <ItemGrid xs={12} sm={6} md={6} marginBottom>
        <AutoCompleteWithStatus
          storeName='inspectionJobWorkspace'
          accessPath={['inspectionFactory', 'country']}
          shrink
          choices={countryList.map(({ region }) => ({
            label: T.translate(`country.${region}`),
            value: region,
            region,
          }))}
        />
      </ItemGrid>
      <ItemGrid xs={12} sm={6} md={6} marginBottom>
        {inspectionJobWorkspaceData.inspectionFactory &&
        (inspectionJobWorkspaceData.inspectionFactory.country === 'China' ||
          inspectionJobWorkspaceData.inspectionFactory.country === 'United States') ? (
          <DropListWithStatus
            storeName='inspectionJobWorkspace'
            accessPath={['inspectionFactory', 'city']}
            shrink
            choices={
              inspectionJobWorkspaceData.inspectionFactory.country === '中國' ||
              inspectionJobWorkspaceData.inspectionFactory.country === 'China'
                ? provinceList.map((rec) => ({
                    label: T.translate(`state.${rec}`),
                    value: rec,
                  }))
                : stateList.map((rec) => ({
                    label: T.translate(`state.${rec}`),
                    value: rec,
                  }))
            }
          />
        ) : (
          <TextFieldWithStatus
            storeName='inspectionJobWorkspace'
            accessPath={['inspectionFactory', 'city']}
            shrink
          />
        )}
      </ItemGrid>
      {/** ** End of Factory Details *** */}

      {/** ** Submit Button *** */}
      <ItemGrid xs={12} sm={12} md={12}>
        <Button
          fullWidth
          variant='contained'
          color='primary'
          onClick={() => {
            handleFormValidation();
          }}
          disabled={workspaceStatus !== 'editing'}>
          {T.translate('inspectionJobWorkspace.submit')}
        </Button>
      </ItemGrid>
      {/** ** End of Submit Button *** */}
    </Grid>,
  ];
};

const mapStateToProps = (state) => ({
  loginState: state.loginState,
  productCategoryList: state.productCategoryList.data,
  inspectionJobWorkspace: state.inspectionJobWorkspace,
});

const mapDispatchToProps = (dispatch, { history }) => ({
  onAutoLogin: () => dispatch(actUserProfileFetch()),
  formInit: () => {
    dispatch(actInspectionJobInit());
    dispatch(actAnyFieldUpdate('inspectionJobWorkspace', ['isQuote'], true));
  },
  onFieldUpdate: (storeName, accessPath, newVal) => {
    dispatch(actAnyFieldUpdate(storeName, accessPath, newVal));
  },
  onSubmit: (data) => {
    dispatch(actInspectionJobSubmit(data, history));
  },
  onLogin: (data) => {
    dispatch(actLogin(data.email, data.password, 'submitting'));
  },
  onSignUp: (data) => {
    dispatch(actQuickRegistration(data));
  },
  onValidate: (schema, data) => {
    dispatch(actValidate('inspectionJobWorkspace', schema, data.data));
  },
  onStateDetailChange: (storeName, key, newVal) => {
    dispatch(actStateDetailChange(storeName, key, newVal));
  },
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    withStyles(combineStyles(icwStyle, loginStyles, quickFormStyles, dzStyles))(
      ProductInspectionCreate
    )
  )
);
